export default "__VITE_ASSET__Dil0nmDj__"